import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const StoreCtx = createContext(null);

export function StoreProvider({ children }) {
  const { user } = useAuth();
  const [stores, setStores] = useState([]);
  const [activeStoreId, setActiveStoreId] = useState(localStorage.getItem("vastrakiran_store") || "");

  const load = async () => {
    if (!user || user.role === "super_admin") { setStores([]); return; }
    try {
      const { data } = await api.get("/stores");
      setStores(data);
      if (activeStoreId && !data.find((s) => s.id === activeStoreId)) {
        setActiveStoreId("");
        localStorage.removeItem("vastrakiran_store");
      }
    } catch { /* ignore */ }
  };

  useEffect(() => { load(); }, [user]);

  const setActive = (id) => {
    setActiveStoreId(id);
    if (id) localStorage.setItem("vastrakiran_store", id);
    else localStorage.removeItem("vastrakiran_store");
  };

  return (
    <StoreCtx.Provider value={{ stores, activeStoreId, setActive, reload: load }}>
      {children}
    </StoreCtx.Provider>
  );
}

export const useStores = () => useContext(StoreCtx);
